module.exports = __webpack_public_path__ + "media/images/services/05-ec9d41c975d513c3632ce0f8eafba2b5.jpg";